import React from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import CircleCheckedFilled from '@material-ui/icons/CheckCircle';
import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked';
import styled, { css } from 'styled-components';
import { FlexContainer, StyledTypography } from 'styles/common';

import theme from 'constants/theme';

const BooleanInputWrapper = styled.div`
  ${(props) =>
    props.disabled &&
    css`
      cursor: initial;
      opacity: 0.65;
      pointer-events: none;
    `}
`;

const BooleanRadioGroup = ({ text1, text2, isEnabled, onChangeHandler, disableInput = false }) => (
  <BooleanInputWrapper disabled={disableInput}>
    <FlexContainer style={{ alignItems: 'center', marginLeft: '-8px' }} topGutter={1}>
      <Checkbox
        color="primary"
        icon={<CircleUnchecked />}
        checkedIcon={<CircleCheckedFilled />}
        style={{ marginRight: '1rem' }}
        checked={isEnabled}
        id={text1}
        onChange={() => onChangeHandler((val) => true)}
      />
      <label style={{ cursor: 'pointer' }} htmlFor={text1}>
        <StyledTypography customColor={theme.palette.text.heading}>{text1}</StyledTypography>
      </label>
    </FlexContainer>
    <FlexContainer style={{ alignItems: 'center', marginLeft: '-8px' }}>
      <Checkbox
        color="primary"
        icon={<CircleUnchecked />}
        checkedIcon={<CircleCheckedFilled />}
        style={{ marginRight: '1rem' }}
        checked={!isEnabled}
        id={text2}
        onChange={() => onChangeHandler((val) => false)}
      />
      <label style={{ cursor: 'pointer' }} htmlFor={text2}>
        <StyledTypography customColor={theme.palette.text.heading}>{text2}</StyledTypography>
      </label>
    </FlexContainer>
  </BooleanInputWrapper>
);

export default BooleanRadioGroup;
